module.exports = __webpack_public_path__ + "static/media/04_DSC0852.03204f6c.jpg";